import { useMutation } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';

export function useDeletePopup() {
  const { mutate: deletePopup } = useMutation(operationApis.deletePopup);

  return { deletePopup };
}
